import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-wizard', 'completedStep', 'Шаг выполнен');
Labels.set('ui-wizard', 'next', 'Далее');
Labels.set('ui-wizard', 'back', 'Назад');
Labels.set('ui-wizard', 'cancel', 'Отмена');
